module.exports = __webpack_public_path__ + "img/cp5-5.9f4d059a.jpg";